import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GenerateCreditNoteConfirmationComponent } from '../generate-credit-note-confirmation/generate-credit-note-confirmation.component';
import { utcToZonedTime, format } from 'date-fns-tz';
import { es } from 'date-fns/locale';
@Component({
  selector: 'app-details-transaction',
  templateUrl: './details-transaction.component.html',
  styleUrls: ['./details-transaction.component.scss'],
})
export class DetailsTransactionComponent implements OnInit {
  constructor(
    private modalsSvc: BsModalService,
    private modalRef: BsModalRef
  ) {}
  transactionInfo!: any;

  ngOnInit(): void {
    
  }

  close() {
    this.modalsSvc.hide();
  }

  createCreditNote() {

    this.modalsSvc.show(GenerateCreditNoteConfirmationComponent, {
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        otherModalRef: this.modalRef,
      },
    });
    
  }

  formatDate(item: string, form: string) {
    let date = new Date(item);
    let zonedDate = utcToZonedTime(date, 'America/Santiago');
    let formatted = format(zonedDate, form, { locale: es });
    return formatted;
  }
  downloadInvoice(voucher:any){
    let element = document.createElement('a');
        element.setAttribute('href', voucher);
        element.setAttribute('target','_blank')
        element.setAttribute('download', 'invoice.pdf'); 
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
  }
}
